var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oval_img_item d-flex"},[_c('img',{staticClass:"flex-shrink-0",attrs:{"src":_vm.img}}),_c('p',{staticClass:"i_body_l"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }